import React, { useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {ReactComponent as Mapchise_logo} from '../Layer_images/Mapchise-logo-white.svg';

const LocationOverviewSidebar = ({ activeTab, onTabChange, sidebarConfig, activeSubTab }) => {
    const [expandedSections, setExpandedSections] = useState({});
    
    const handleSectionToggle = (sectionId) => {
        setExpandedSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));
    };

    // Auto-expand the section containing the active subtab
    React.useEffect(() => {
        if (activeSubTab && sidebarConfig) {
            const parentTab = sidebarConfig.find(tab => 
                tab.children && tab.children.find(child => child.id === activeSubTab)
            );
            if (parentTab) {
                setExpandedSections(prev => ({
                    ...prev,
                    [parentTab.id]: true
                }));
            }
        }
    }, [activeSubTab, sidebarConfig]);

    // Default tabs if no custom configuration is provided
    const defaultTabs = [
        { id: 'overview', label: 'Overview', component: 'OverviewTopSection' },
        { id: 'performers', label: 'Customer Locations', component: 'OverviewTopPerformers' }
    ];

    // Use custom configuration if available, otherwise use defaults
    const tabs = sidebarConfig && sidebarConfig.length > 0 ? sidebarConfig : defaultTabs;

    // Sort tabs by order if they have it
    const sortedTabs = [...tabs].sort((a, b) => (a.order || 0) - (b.order || 0));

    return (
        <Box
            sx={{
                position: 'fixed',
                width: '180px',
                backgroundColor: '#1570ef',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '20px',
                // py: 2
            }}
        >
            {/* Logo Section */}
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                padding: '5px 0px 15px 0px;'
            }}>
                <Mapchise_logo style={{ width: '140px', height: 'auto' }} />
            </Box>

            {sortedTabs.map((tab) => (
                <div key={tab.id}>
                    {tab.isSection || tab.children ? (
                        // Section with dropdown
                        <div>
                            <div
                                onClick={() => {
                                    handleSectionToggle(tab.id);
                                    onTabChange(tab.id, null); // Also navigate to the tab
                                }}
                                style={{
                                    padding: '20px',
                                    cursor: 'pointer',
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    borderRadius: 'none',
                                    transition: 'all 0.2s ease-in-out',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'white',
                                        fontWeight: activeTab === tab.id ? 600 : 500,
                                        fontSize: '14px',
                                        lineHeight: 1.2,
                                        textAlign: 'left'
                                    }}
                                >
                                    {tab.label}
                                </Typography>
                                {expandedSections[tab.id] ? 
                                    <ExpandLessIcon sx={{ color: 'white', fontSize: 18 }} /> : 
                                    <ExpandMoreIcon sx={{ color: 'white', fontSize: 18 }} />
                                }
                            </div>
                            <Collapse in={expandedSections[tab.id]} timeout="auto" unmountOnExit>
                                {tab.children && tab.children
                                    .filter(child => child.type !== 'graph') // Only show non-graph items in sidebar
                                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                                    .map((child) => (
                                    <div
                                        key={child.id}
                                        onClick={() => onTabChange(tab.id, child.id)} // Pass both tab and subtab
                                        style={{
                                            paddingLeft: '40px',
                                            paddingRight: '20px',
                                            paddingTop: '10px',
                                            paddingBottom: '10px',
                                            cursor: 'pointer',
                                            backgroundColor: activeSubTab === child.id ? '#2e90fa' : 'transparent',
                                            color: 'white',
                                            borderRadius: activeSubTab === child.id ? '4px 0 0 4px' : 'none',
                                            transition: 'all 0.2s ease-in-out'
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: 'white',
                                                fontWeight: activeSubTab === child.id ? 600 : 400,
                                                fontSize: '13px',
                                                lineHeight: 1.2,
                                                textAlign: 'left'
                                            }}
                                        >
                                            {child.label}
                                        </Typography>
                                    </div>
                                ))}
                            </Collapse>
                        </div>
                    ) : (
                        // Regular tab
                        <div
                            onClick={() => onTabChange(tab.id, null)}
                            style={{
                                padding: '20px',
                                cursor: 'pointer',
                                backgroundColor: activeTab === tab.id && !activeSubTab ? '#2e90fa' : 'transparent',
                                color: 'white',
                                borderRadius: activeTab === tab.id && !activeSubTab ? '4px 0 0 4px' : 'none',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'white',
                                    fontWeight: activeTab === tab.id && !activeSubTab ? 600 : 400,
                                    fontSize: '14px',
                                    lineHeight: 1.2,
                                    textAlign: 'left'
                                }}
                            >
                                {tab.label}
                            </Typography>
                        </div>
                    )}
                </div>
            ))}
        </Box>
    );
};

export default LocationOverviewSidebar;